import { message as antdMessage } from 'antd';
import { get } from 'lodash';

export const DEFAULT_ERROR = 'Server error. Please retry or contact support.';

// This is a WIP solution to handle network/server errors in a consistent way across pages
// axios handles some global cases like 429
// in some scenarios we should not show the server error message as is to the user
// and in some cases we can show the message from the server
// doing this "right" requires replacing all variations of axios with the axiosInstance config so that errors contain response object
// now the instances used in auto request store only returns a parsed object
// error.response.status vs error.code
export function handleServerError(error) {

  const code = get(error, 'code', null);
  // 429 is handled by axios globally, avoid redundant alerts
  if(code === 429) { return; }

  const { message = DEFAULT_ERROR } =  error;
  antdMessage.error(message);
}
